function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import ActionTypes from '../../../ActionsTypes';
import InitialState from './initialState';
var initialState = new InitialState();
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var obj = {};
  var newRates = 0;

  switch (action.type) {
    case ActionTypes.ADD_TO_CART:
      action.payload.input.dataRates.map( // eslint-disable-next-line no-return-assign
      function (a) {
        return obj[a] = {
          show: true,
          price: 10
        };
      });
      return {
        plots: _objectSpread({}, state.plots, _defineProperty({}, action.payload.input.id, {
          show: true,
          rates: obj,
          _id: action.payload.input.id,
          price: 10
        }))
      };

    case ActionTypes.REMOVE_FROM_CART:
      Object.keys(state.plots).map(function (a) {
        Object.keys(state.plots[a].rates).map(function (x) {
          if (state.plots[a].rates[x].show === true) newRates += 1;
        });
      });

      if (newRates === 1) {
        var newPlots = {};
        Object.keys(state.plots).map(function (a) {
          if (a != action.payload.key) {
            newPlots[a] = state.plots[a];
          }
        });
        return {
          plots: _objectSpread({}, newPlots)
        };
      }

      return {
        plots: _objectSpread({}, state.plots, _defineProperty({}, action.payload.key, {
          rates: _objectSpread({}, state.plots[action.payload.key].rates, _defineProperty({}, action.payload.rate, {
            show: false
          }))
        }))
      };

    default:
      return state;
  }
});